import { css } from 'styled-components'
import ofc from '../../settings/variables'
import ModalBottom from '../ModalBottom'
import ModalContent from '../ModalContent'

const styles = css`
    display:${props => props.show ? 'block' : 'none'};
    position: fixed;
    width:100%;
    height:100%;
    z-index:100;
    background-color: rgba(0,0,0,${props => props.opacity || '0.5'});
    top:0;
    bottom:0;
    left:0;
    right:0;
    
    ${ModalBottom}{
        height: 90vh;
        height: 90dvh;
        max-height: 90vh;
        max-height: 90dvh;
        display: flex;
        flex-direction: column;
    }

    ${ModalContent}{
        flex: 1 1 auto;
        min-height: 0;
        display: flex;
        flex-direction: column;
    }

    //OverWrite tabs Styles
    .ow-tabs{
        color: ${ofc.textColor};
        flex: 1 1 auto;
        min-height: 0;
        display: flex;
        flex-direction: column;
    }
    .ow-tabs .ant-tabs-content-holder{
        flex: 1 1 auto;
        min-height: 0;
        overflow: hidden;
    }
    .ow-tabs .ant-tabs-content,
    .ow-tabs .ant-tabs-tabpane{
        height: 100%;
    }
    .ow-tabs .ant-tabs-tabpane{
        overflow-y: auto;
        -webkit-overflow-scrolling: touch;
    }
    .ow-tabs .ant-tabs-tab.ant-tabs-tab-active .ant-tabs-tab-btn{
        color: ${ofc.primary};
    }

    .ow-tabs .ant-tabs-ink-bar{
        background-color: ${ofc.primary};
    }


`

export default styles
    
